<template>
  <div>

    <img :src="obj2.src" :key="key" v-for="(obj2, key) in imgList" @click="handleImgView(obj2.src)" height="25px"
      width="50px" alt=""
      style="max-width:80px;border: 2px solid #dcdcdc;font-size: 12px;font-style: italic;cursor: pointer;" />
    <a-modal :mask="false" :width="1000" :title="'圖片詳情'" :visible="previewVisible" :confirm-loading="false"
      :ok-button-props="{ props: { disabled: true } }" @cancel="handleCancel" :cancelText="'關閉'">
      <img alt="example" style="width: 100%;" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>

import { deleteAction, getAction, downFile, getFileAccessHttpUrl } from '@/api/manageChooseSeat'
// import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
export default {
  name: 'ImageView',
  // mixins: [JeecgListMixin],
  components: {

  },
  data() {
    return {
      title: '查看图片',
      width: 200,
      visible: false,
      imgList: [],
      previewVisible: false,
      previewImage: '',
      isImage: false
    }
  },

  methods: {
    viewimage(imgpath) {
      this.imgList = [];
      if (imgpath != "") {
        let arr = imgpath.split(",")
        for (let i = 0; i < arr.length; i++) {
          let url = getFileAccessHttpUrl(arr[i] + "?applicationCode=chooseseat")
          let c = { key: i, src: url, filename: arr[i] }
          this.imgList.push(c);

        }
      }

    },
    handleImgView(text) {
      this.previewImage = text;
      this.previewVisible = true;
    },
    //关闭图片预览框
    handleCancel() {
      this.previewVisible = false;
    },

  }
}
</script>

<style scoped></style>